/* Aspen Grove: progressive storefront interactions. Native forms remain usable. */
(function () {
  'use strict';
  var AGF = window.AGF = window.AGF || {};
  var config = AGF.settings || {};
  var root = config.root || (window.Shopify && window.Shopify.routes.root) || '/';
  var activeDialog = null;
  var returnFocus = null;
  var cartQueue = Promise.resolve();
  var pendingCart = 0;
  var popupKey = 'agf-berry-club-dismissed';

  AGF.formatMoney = function (cents) {
    return new Intl.NumberFormat(config.locale || 'en-US', {
      style: 'currency', currency: config.currency || 'USD'
    }).format(Number(cents) / 100);
  };
  AGF.toast = function (message) {
    var node = document.querySelector('.agf-toast');
    if (!node) {
      node = document.createElement('div'); node.className = 'agf-toast';
      node.setAttribute('role', 'status'); node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    node.textContent = message; node.classList.add('is-visible');
    clearTimeout(node.timer); node.timer = setTimeout(function () { node.classList.remove('is-visible'); }, 5000);
  };
  AGF.track = function (name, params) {
    if (config.metaPixelEnabled && typeof window.fbq === 'function') window.fbq('track', name, params || {});
    document.dispatchEvent(new CustomEvent('agf:track', { detail: { event: name, params: params || {} } }));
  };
  function closeDialog() {
    if (!activeDialog) return;
    var old = activeDialog; activeDialog = null;
    old.classList.remove('is-open'); old.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.querySelectorAll('[data-dialog-inert]').forEach(function (el) { el.inert = false; el.removeAttribute('data-dialog-inert'); });
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    returnFocus = null;
  }
  function openDialog(node) {
    if (!node || activeDialog === node) return;
    closeDialog(); returnFocus = document.activeElement; activeDialog = node;
    node.classList.add('is-open'); node.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Inert siblings along the ancestor chain, including dynamically rendered sections.
    var branch = node;
    while (branch && branch.parentElement && branch.parentElement !== document.documentElement) {
      Array.from(branch.parentElement.children).forEach(function (sibling) {
        if (sibling !== branch && !sibling.inert && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
          sibling.inert = true; sibling.setAttribute('data-dialog-inert', '');
        }
      });
      branch = branch.parentElement;
    }
    var focus = node.querySelector('button, input, a[href], select');
    if (focus) focus.focus();
  }
  AGF.openCart = function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) { window.location.assign(root + 'cart'); return; }
    openDialog(drawer);
  };
  AGF.closeCart = function () { if (activeDialog && activeDialog.id === 'CartDrawer') closeDialog(); };
  function closePopup() {
    if (!activeDialog || activeDialog.id !== 'EmailPopup') return;
    closeDialog(); try { localStorage.setItem(popupKey, String(Date.now())); } catch (_) {}
  }
  window.AGFClosePopup = closePopup;

  async function requestJSON(url, options) {
    var response = await fetch(url, options);
    var data;
    try { data = await response.json(); } catch (_) { throw new Error('We could not read the store response. Please refresh and check your cart.'); }
    if (!response.ok) throw new Error(data.description || data.message || 'The store could not update your cart.');
    return data;
  }
  function sectionsToRender() {
    return Array.from(document.querySelectorAll('#CartDrawer, [data-cart-page]')).map(function (el) {
      return el.getAttribute('data-section-id');
    }).filter(Boolean);
  }
  function refreshCart(cart, sections) {
    AGF.cart = cart;
    var note = document.querySelector('#CartNote');
    var noteValue = note ? note.value : null;
    var focus = document.activeElement;
    var focusKey = focus && focus.getAttribute('data-line-key');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
    });
    var failed = false;
    document.querySelectorAll('#CartDrawer, [data-cart-page]').forEach(function (target) {
      var html = sections && sections[target.getAttribute('data-section-id')];
      if (!html) { failed = true; return; }
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(target.id ? '#CartDrawer' : '[data-cart-page]');
      if (!fresh) { failed = true; return; }
      target.innerHTML = fresh.innerHTML;
    });
    if (noteValue !== null && document.querySelector('#CartNote')) document.querySelector('#CartNote').value = noteValue;
    if (activeDialog) {
      var replacement = focusKey && Array.from(activeDialog.querySelectorAll('input[data-line-key]')).find(function (el) { return el.getAttribute('data-line-key') === focusKey; });
      if (!activeDialog.contains(document.activeElement)) (replacement || activeDialog.querySelector('button')).focus();
    }
    document.dispatchEvent(new CustomEvent('agf:cart:updated', { detail: { cart: cart } }));
    return !failed;
  }
  function restoreQuantities() {
    document.querySelectorAll('input[data-line-key]').forEach(function (input) {
      var item = AGF.cart && AGF.cart.items.find(function (line) { return line.key === input.getAttribute('data-line-key'); });
      if (item) input.value = item.quantity;
    });
  }
  function updateBusyState() {
    document.querySelectorAll('#CartDrawer, [data-cart-page]').forEach(function (el) { el.setAttribute('aria-busy', pendingCart ? 'true' : 'false'); });
    document.querySelectorAll('input[data-line-key]').forEach(function (input) { input.readOnly = pendingCart > 0; });
    document.querySelectorAll('[name="checkout"]').forEach(function (b) { b.disabled = pendingCart > 0; });
  }
  function enqueueCart(work) {
    pendingCart++; updateBusyState();
    var task = cartQueue.then(work);
    cartQueue = task.catch(function () {});
    return task.finally(function () { pendingCart--; updateBusyState(); });
  }
  async function mutateCart(endpoint, payload, adding) {
    payload.sections = sectionsToRender(); payload.sections_url = window.location.pathname;
    var result = await requestJSON(root + 'cart/' + endpoint + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
    });
    // A successful mutation must never be retried just because rendering fails.
    try {
      var cart = adding ? await requestJSON(root + 'cart.js') : result;
      if (!refreshCart(cart, result.sections)) throw new Error('section-render');
      updateBusyState(); return cart;
    } catch (_) {
      AGF.toast('Your cart changed. Open the full cart to see the latest items.');
      window.location.assign(root + 'cart');
      return null;
    }
  }
  AGF.addToCart = function (items, options) {
    options = options || {};
    return enqueueCart(async function () {
      var cart = await mutateCart('add', { items: items }, true);
      if (cart) {
        items.forEach(function (item) { AGF.track('AddToCart', { content_ids: [String(item.id)], content_type: 'product_variant', currency: config.currency, value: options.value, contents: [{ id: String(item.id), quantity: item.quantity }] }); });
        if (config.cartType === 'drawer') AGF.openCart(); else window.location.assign(root + 'cart');
      }
      return cart;
    }).catch(function (error) { AGF.toast(error.message || 'Could not add this item. Please check your cart.'); throw error; });
  };
  AGF.changeLine = function (key, quantity) {
    return enqueueCart(function () { return mutateCart('change', { id: key, quantity: quantity }, false); })
      .catch(function (error) { restoreQuantities(); AGF.toast(error.message || 'Could not update the quantity.'); throw error; });
  };
  async function quickAdd(button) {
    if (button.disabled || button.classList.contains('is-loading')) return;
    button.disabled = true; button.classList.add('is-loading');
    try { await AGF.addToCart([{ id: button.getAttribute('data-quick-add'), quantity: 1 }]); }
    catch (_) {} finally { button.disabled = false; button.classList.remove('is-loading'); }
  }
  function closeShopMenus(restoreFocus) {
    document.querySelectorAll('[data-shop-menu][open]').forEach(function (menu) {
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary').focus();
    });
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-shop-menu]')) closeShopMenus(false);
  });
  document.addEventListener('focusin', function (event) {
    if (!event.target.closest('[data-shop-menu]')) closeShopMenus(false);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeShopMenus(true);
  });
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-bundle-tier], button, a, [data-cart-close], [data-menu-close], [data-popup-close]');
    if (!target) return;
    if (target.matches('[data-bundle-tier]')) {
      var tierForm = target.closest('form');
      tierForm.querySelector('[name="quantity"]').value = target.getAttribute('data-bundle-qty');
      tierForm.querySelectorAll('[data-bundle-tier]').forEach(function (tier) { tier.classList.toggle('is-selected', tier === target); });
      return;
    }
    if (target.matches('[data-cart-open]') && config.cartType === 'drawer') { event.preventDefault(); AGF.openCart(); return; }
    if (target.matches('[data-cart-close], [data-menu-close]')) { closeDialog(); return; }
    if (target.matches('[data-popup-close]')) { closePopup(); return; }
    if (target.matches('[data-menu-open]')) { openDialog(document.getElementById('MobileMenu')); target.setAttribute('aria-expanded', 'true'); return; }
    if (target.matches('[data-quick-add]')) { event.preventDefault(); quickAdd(target); return; }
    if (target.matches('[data-line-remove]')) { event.preventDefault(); if (pendingCart) return; AGF.changeLine(target.getAttribute('data-line-remove'), 0).catch(function () {}); return; }
    if (target.matches('[data-qty-change]')) {
      var input = target.closest('.qty-input').querySelector('input');
      var key = input.getAttribute('data-line-key'); if (key && pendingCart) return;
      var next = Number(input.value) + (target.getAttribute('data-qty-change') === 'up' ? 1 : -1);
      next = Math.max(Number(input.min || 0), Number.isFinite(next) ? Math.floor(next) : 1);
      if (input.max) next = Math.min(next, Number(input.max)); input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    if (target.matches('[data-sticky-atc]')) {
      var form = document.querySelector('form[data-type="add-to-cart-form"]');
      var add = form && form.querySelector('[data-atc-button]'); if (add && !add.disabled && !add.classList.contains('is-loading')) form.requestSubmit(add);
    }
  });
  // Founders' Wall preferences → cart attributes (saved quietly; also submitted with the checkout form)
  var attrTimer = null;
  document.addEventListener('change', function (event) {
    var field = event.target.closest('[data-cart-attribute]');
    if (!field) return;
    var attrs = {};
    document.querySelectorAll('[data-cart-attribute]').forEach(function (el) {
      var key = el.getAttribute('data-cart-attribute');
      if (el.type === 'checkbox') attrs[key] = el.checked ? el.getAttribute('data-attribute-on') : el.getAttribute('data-attribute-off');
      else attrs[key] = el.value.trim();
    });
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
    }, 300);
  });
  document.addEventListener('input', function (event) {
    var field = event.target.closest('input[data-cart-attribute][type="text"]');
    if (field) field.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (event) {
    var input = event.target.closest('input[data-line-key]');
    if (!input) return;
    if (pendingCart) { restoreQuantities(); return; }
    var qty = Number(input.value);
    if (!Number.isInteger(qty) || qty < 0) { restoreQuantities(); AGF.toast('Enter a whole-number quantity of zero or more.'); return; }
    AGF.changeLine(input.getAttribute('data-line-key'), qty).catch(function () {});
  });
  document.addEventListener('keydown', function (event) {
    if (!activeDialog) return;
    if (event.key === 'Escape') { if (activeDialog.id === 'EmailPopup') closePopup(); else closeDialog(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(activeDialog.querySelectorAll('a[href], button:not(:disabled), input:not([type="hidden"]), select, textarea, [tabindex="0"]')).filter(function (el) { return !el.hidden && el.getClientRects().length > 0; });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('submit', function (event) {
    if (event.submitter && event.submitter.name === 'checkout') {
      if (pendingCart) { event.preventDefault(); AGF.toast('Finishing your cart update. Please try checkout again.'); return; }
      if (AGF.cart) AGF.track('InitiateCheckout', { currency: config.currency, value: AGF.cart.total_price / 100, num_items: AGF.cart.item_count });
    }
  });

  function initProducts() {
    document.querySelectorAll('[data-product-form]').forEach(function (container) {
      if (container.dataset.initialized) return; container.dataset.initialized = 'true';
      var product = JSON.parse(container.querySelector('[data-product-json]').textContent);
      var form = container.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      var selector = form.querySelector('[name="id"]');
      var button = form.querySelector('[data-atc-button]');
      var sticky = document.querySelector('[data-sticky-atc]');
      var busy = false;
      function variant() { return product.variants.find(function (v) { return String(v.id) === selector.value; }); }
      function renderVariant(updateURL) {
        var selected = variant(); var enabled = !!selected && selected.available;
        var label = enabled ? (button.getAttribute('data-label-add') || 'Add to cart') : (selected ? 'Sold out' : 'Unavailable');
        [button, sticky].filter(Boolean).forEach(function (b) { b.disabled = busy || !enabled; b.querySelector('.btn-label').textContent = label; });
        if (!selected) return;
        var price = container.querySelector('[data-price-wrap]');
        price.innerHTML = '<div class="price price--large"><span class="price__current"></span></div>';
        price.querySelector('.price__current').textContent = AGF.formatMoney(selected.price);
        if (selected.unit_price && selected.unit_price_measurement) {
          var unit = document.createElement('span'); unit.className = 'price__unit';
          var measure = selected.unit_price_measurement;
          unit.textContent = AGF.formatMoney(selected.unit_price) + ' / ' + (measure.reference_value === 1 ? '' : measure.reference_value) + measure.reference_unit;
          price.firstChild.appendChild(unit);
        }
        if (selected.compare_at_price > selected.price) {
          var compare = document.createElement('s'); compare.className = 'price__compare'; compare.textContent = AGF.formatMoney(selected.compare_at_price); price.firstChild.appendChild(compare);
          if (price.hasAttribute('data-bundle-price')) {
            var separate = document.createElement('span'); separate.className = 'visually-hidden'; separate.textContent = price.getAttribute('data-price-separate') + ': '; compare.prepend(separate);
            var saving = document.createElement('span'); saving.className = 'price__save'; saving.textContent = price.getAttribute('data-price-save').replace('[[amount]]', AGF.formatMoney(selected.compare_at_price - selected.price)); price.firstChild.appendChild(saving);
          }
        }
        var stickyPrice = document.querySelector('[data-sticky-price]'); if (stickyPrice) stickyPrice.textContent = AGF.formatMoney(selected.price);
        if (updateURL) {
          var url = new URL(window.location.href); url.searchParams.set('variant', selected.id); window.history.replaceState({}, '', url);
          if (selected.featured_image) {
            var gallery = container.querySelector('.product-gallery__main img');
            if (gallery) { gallery.removeAttribute('srcset'); gallery.src = selected.featured_image.src; gallery.alt = selected.featured_image.alt || product.title; }
          }
        }
      }
      selector.addEventListener('change', function () { renderVariant(true); });
      form.addEventListener('submit', async function (event) {
        event.preventDefault(); var selected = variant(); if (busy || !selected || !selected.available || !form.reportValidity()) return;
        var quantity = Number(form.querySelector('[name="quantity"]').value);
        if (!Number.isInteger(quantity) || quantity < 1) { AGF.toast('Choose a whole-number quantity of at least one.'); return; }
        var item = { id: selected.id, quantity: quantity };
        var fields = new FormData(form);
        if (fields.get('selling_plan')) item.selling_plan = fields.get('selling_plan');
        fields.forEach(function (value, key) { var match = /^properties\[(.+)\]$/.exec(key); if (match) { item.properties = item.properties || {}; item.properties[match[1]] = value; } });
        busy = true; button.classList.add('is-loading'); renderVariant(false);
        try { await AGF.addToCart([item], { value: selected.price * quantity / 100 }); }
        catch (_) {} finally { busy = false; button.classList.remove('is-loading'); renderVariant(false); }
      });
      renderVariant(false);
      var selected = variant(); if (selected) AGF.track('ViewContent', { content_ids: [String(selected.id)], content_name: product.title, content_type: 'product_variant', value: selected.price / 100, currency: config.currency });
    });
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.initialized) return; gallery.dataset.initialized = 'true';
      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-full]'); if (!thumb) return;
        var main = gallery.querySelector('.product-gallery__main img');
        main.removeAttribute('srcset'); main.src = thumb.dataset.full; main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-full]').forEach(function (b) { b.classList.toggle('is-active', b === thumb); b.setAttribute('aria-pressed', b === thumb ? 'true' : 'false'); });
      });
    });
    var bar = document.querySelector('.sticky-atc'); var anchor = document.querySelector('.qty-and-atc');
    if (bar && anchor && !bar.dataset.initialized && 'IntersectionObserver' in window) {
      bar.dataset.initialized = 'true'; bar.inert = true;
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible); bar.setAttribute('aria-hidden', visible ? 'false' : 'true'); bar.inert = !visible;
      }).observe(anchor);
    }
  }
  function initPopup() {
    var popup = document.getElementById('EmailPopup'); if (!popup || popup.dataset.initialized) return;
    popup.dataset.initialized = 'true';
    if (popup.querySelector('[data-popup-result]') && window.location.hash === '#PopupNewsletter') { openDialog(popup); return; }
    if (document.body.classList.contains('template-cart') || document.body.classList.contains('template-customers/login') || (window.Shopify && window.Shopify.designMode)) return;
    try { var dismissed = Number(localStorage.getItem(popupKey)); if (dismissed && Date.now() - dismissed < Number(popup.dataset.daysHidden || 30) * 86400000) return; } catch (_) {}
    var shown = false, ready = false;
    function maybeShow() {
      if (shown || !ready || activeDialog || document.activeElement.matches('input, textarea, select') || window.scrollY < Math.min(500, document.documentElement.scrollHeight * .25)) return;
      shown = true; openDialog(popup); window.removeEventListener('scroll', maybeShow);
    }
    setTimeout(function () { ready = true; maybeShow(); }, Number(popup.dataset.delay || 30) * 1000);
    window.addEventListener('scroll', maybeShow, { passive: true });
    // Native Shopify customer form handles validation, challenges, errors and confirmation.
  }
  function initOther() {
    document.querySelectorAll('[data-sort-by]').forEach(function (select) {
      if (select.dataset.initialized) return; select.dataset.initialized = 'true';
      select.addEventListener('change', function () { var url = new URL(window.location.href); url.searchParams.set('sort_by', select.value); url.searchParams.delete('page'); window.location.assign(url); });
    });
    document.querySelectorAll('.video-poster').forEach(function (poster) {
      if (poster.dataset.initialized) return; poster.dataset.initialized = 'true';
      poster.addEventListener('click', function () { var frame = document.createElement('iframe'); frame.src = poster.dataset.videoUrl; frame.title = poster.dataset.videoTitle || 'Farm video'; frame.allow = 'autoplay; encrypted-media; picture-in-picture'; frame.allowFullscreen = true; poster.closest('.video-section__frame').replaceChildren(frame); });
    });
  }
  function init() { initProducts(); initPopup(); initOther(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) { if (activeDialog && event.target.contains(activeDialog)) closeDialog(); });
})();
